import React from "react";

// Reusable SEO content block placed at the bottom of every page.
// `variant` selects which keyword-rich content to render.
export default function SeoContent({ variant = "home" }) {
  const content = SEO[variant] || SEO.home;
  return (
    <section className="max-w-5xl mx-auto px-4 mt-8">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-7 seo-prose">
        {content}
      </div>
    </section>
  );
}

const SEO = {
  home: (
    <>
      <h2>Sunday Ground Teer Result Today - Fast, Accurate &amp; Trusted</h2>
      <p>
        Welcome to <strong>Sunday Ground Teer</strong>, your trusted destination for the fastest and
        most accurate <strong>Sunday Ground Teer Result</strong>. Here you can check today's Shillong
        Teer First Round (F/R) and Second Round (S/R) results, along with the Direct, House and Ending
        numbers as soon as they are announced. Our goal is to bring you reliable teer results, common
        numbers, dream numbers and previous results all in one simple place.
      </p>
      <h3>What is Sunday Ground Teer?</h3>
      <p>
        Sunday Ground Teer is a traditional archery-based number game popular in Meghalaya and the
        North-East. Two rounds are played daily and the results are declared as two-digit numbers. The
        F/R (First Round) result is usually declared around 4:30 PM and the S/R (Second Round) around
        5:30 PM. On this site you will always find the latest updated result the moment it is out.
      </p>
      <h3>Why check results here?</h3>
      <ul>
        <li>Today's <strong>Sunday Ground Teer Result</strong> updated instantly</li>
        <li>Accurate <strong>Common Number</strong> and <strong>Dream Number</strong> guidance</li>
        <li>Complete <strong>Previous Result</strong> archive from 2019 to 2026</li>
        <li>Daily Analysis (Guti) and Predict Target for House &amp; Ending</li>
        <li>Teer Club Chart with date-wise lookup</li>
      </ul>
      <p>
        Bookmark Sunday Ground Teer and visit daily for the most trusted teer result updates. Please
        remember that teer is a game of chance - always play responsibly.
      </p>
    </>
  ),
  common: (
    <>
      <h2>Sunday Ground Teer Common Number Today</h2>
      <p>
        The <strong>Common Number</strong> section on Sunday Ground Teer shows the most frequently
        appearing and most probable numbers for today's teer, calculated from past results. These
        common numbers include Direct picks, House digits and Ending digits for both F/R and S/R.
      </p>
      <p>
        Many players use the common number as a reference before the result is declared. Remember that
        a common number is only a probability-based suggestion derived from previous results and does
        not guarantee any outcome. Use it wisely and play responsibly.
      </p>
      <h3>How is the Common Number calculated?</h3>
      <p>
        We study the frequency of Direct, House and Ending numbers over recent draws and highlight the
        digits that repeat most often. This helps you spot patterns quickly for Sunday Ground Teer.
      </p>
    </>
  ),
  dream: (
    <>
      <h2>Sunday Ground Teer Dream Number - Full Meaning Guide</h2>
      <p>
        The <strong>Dream Number</strong> chart connects what you see in your dreams with traditional
        lucky numbers used by the teer community. If you dreamt of a snake, water, fire, money or any
        common object, find its associated Direct, House and Ending numbers below.
      </p>
      <p>
        Dream numbers are based on age-old beliefs and are meant for reference and entertainment. There
        is no scientific guarantee, so always play the Sunday Ground Teer responsibly.
      </p>
      <h3>Popular dreams and their numbers</h3>
      <p>
        Snake, water, fire, gold, marriage, baby, blood and fish are among the most searched dreams.
        Our chart keeps the most common dreams updated so you never miss your lucky number.
      </p>
    </>
  ),
  previous: (
    <>
      <h2>Sunday Ground Teer Previous Result (2019 - 2026)</h2>
      <p>
        Browse the complete <strong>Previous Result</strong> archive of Sunday Ground / Shillong Teer
        from 2019 all the way to 2026. Every entry shows the City, Date, First Round (F/R) and Second
        Round (S/R) numbers so you can study patterns and history at a glance.
      </p>
      <p>
        Previous results are the foundation of good analysis. By reviewing past F/R and S/R numbers you
        can understand trends, repeat numbers and hot/cold digits for Sunday Ground Teer.
      </p>
      <h3>How to use previous results</h3>
      <ul>
        <li>Compare F/R and S/R history across dates</li>
        <li>Identify repeating House and Ending digits</li>
        <li>Combine with today's Common Number and Analysis</li>
      </ul>
    </>
  ),
};
